<template>
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="20" cy="20" r="20" fill="#E8E8E8"/>
    <rect x="17.1797" y="11" width="12.9805" height="1.29805" transform="rotate(45 17.1797 11)" fill="black"/>
    <rect x="26.3584" y="20.1777" width="12.9805" height="1.29805" transform="rotate(135 26.3584 20.1777)" fill="black"/>
  </svg>
</template>